import { shouldShowFolderPane } from './shouldShowFolderPane';
import { shouldShowFolderPaneAsOverlay } from './shouldShowFolderPaneAsOverlay';
import { shouldShowFolderPaneAsTransientOverlay } from './shouldShowFolderPaneAsTransientOverlay';

/**
 * Returns whether the folder pane is currently open as an overlay, covering both the
 * Win32 transient overlay and the narrow-window overlay.
 */
export function isFolderPaneOverlayOpen(): boolean {
    return (
        shouldShowFolderPaneAsTransientOverlay() ||
        (shouldShowFolderPane() && shouldShowFolderPaneAsOverlay())
    );
}
